import { Box, Button, CircularProgress, Tab, Tabs } from "@mui/material"
import { useState } from "react"
import CustomDialog from "../../../components/layouts/common/CustomDialog"
import { CenteredBox } from "../../../components/layouts/OneViewBox"
import EventDetails from "./EventDetails"
import UserProfileViewCommonController from "../../user/UserProfileViewCommonController"
import BeneficiaryDetails from "./BeneficiaryDetails"
import ImageDetails from "./ImageDetails"
import { useDispatch } from "react-redux"
import { callApiAction } from "../../../store/actions/commonAction"
import { getSummaryOfBeneficiaryStages } from "../../../apis/followup.api"
import fileDownload from "js-file-download"


const DetailedViewMain = ({ data, loading, setData, modalKey }) => {
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0)
     const [pdfLoading, setpdfLoading] = useState(false)
    const handleTabChange = (e, newVal) => {
        setTab(newVal)
    }
const fetchSummaryPdfDownload = () => {
    setpdfLoading(true);
    dispatch(
      callApiAction(
        async () =>
          await getSummaryOfBeneficiaryStages({
            eventId: data?._id, 
          }),
        (response) => {
          // setList(response)
          console.log("RESPONSE", response);
          fileDownload(response, "beneficiary_report.pdf");
          setpdfLoading(false);
        },
        (err) => {
          console.log(err);
          setpdfLoading(false);
        },
        true
      )
    );
  };
  const onPdfBtnClick = () => {
    fetchSummaryPdfDownload();
  };

    return <>
       <CustomDialog
        id={modalKey}
        loading={loading}
        title={`Event Details`}
        closeText="Close"
        dialogProps={{ width: "100%" }}
    >
        <Box sx={{ width: "100%", overflow: "hidden" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: 1, borderColor: "divider", background: "white", position: "sticky", top: 0, zIndex: 11 }}>
                <Tabs
                    sx={{ width: '100%' }}
                    scrollButtons
                    allowScrollButtonsMobile
                    value={tab}
                    onChange={handleTabChange}
                >
                    <Tab label="Event Details" />
                    <Tab label="Beneficiaries" />
                    <Tab label="Gallery" />
                </Tabs>
                <Button   variant="contained"
                    color="primary"
                    onClick={onPdfBtnClick}
                    sx={{ ml: 2, minWidth: 320 }}
                    disabled={pdfLoading}
                >
                    {pdfLoading ? <CircularProgress size={20} color="inherit" /> : "Download Beneficiary Report"}
                </Button>
            </Box>
        </Box>
        {loading ? <CenteredBox><CircularProgress size={30} /></CenteredBox> :
            <Box mt={3} sx={{ width: '100%' }}>
                {
                    <EventDetails show={tab == 0} data={data} />
                }
                {
                    <BeneficiaryDetails show={tab == 1} data={data} />
                }
                {
                    <ImageDetails show={tab == 2} data={data} />
                }
            </Box>}
        </CustomDialog>
    </>
}
export default DetailedViewMain